import SOCHomeView from '../../components/SOCHomeView';

SOCHomeScreen.propTypes = {};

function SOCHomeScreen(props) {
  return (
    <div className="vh-100 overflow-hidden">
      <SOCHomeView />
    </div>
  );
}

export default SOCHomeScreen;
